import { render } from "./EditStepScenarioTap.vue?vue&type=template&id=6ff24766&scoped=true"
import script from "./EditStepScenarioTap.vue?vue&type=script&lang=js"
export * from "./EditStepScenarioTap.vue?vue&type=script&lang=js"

import "./EditStepScenarioTap.vue?vue&type=style&index=0&id=6ff24766&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff24766"]])

export default __exports__